import React from 'react';
import {injectIntl} from "react-intl";
import ParkPlanning from "./ParkPlanning";

class CarParkPlanning extends React.Component {

  render() {
    const {intl:{formatMessage}} = this.props;
    return (
      <div>
        <header className="main-header">
          <div className="main-header__left">
            <h1 className="main__title">
              {formatMessage({id:'section.car-park-planning.title'})}
            </h1>
          </div>
        </header>

        <div className="main__content">
          <section className="box">
            <header className="box-heading">
              <h2 className="box-heading__title">
                {formatMessage({id:'section.car-park-planning.title'})}
              </h2>
            </header>

            <div className="box__body">
              <ParkPlanning/>
            </div>
          </section>
        </div>
      </div>
    )
  }
}

export default injectIntl(CarParkPlanning);
